import React from "react";
import { connect } from 'react-redux';
import {
    Card,
    Table,
} from "reactstrap";
import { motion } from "framer-motion";
import { PayPalButtons } from "@paypal/react-paypal-js";
import { sendPaypalTransaction } from '../redux/actions/rLink.action';
import { useTranslation } from "react-i18next";
import features from '../variables/features';
import { toast } from 'react-toastify';

function renderFeature ( t, data, plan ) {
    if (data.unlimited) {
        if (data.unlimited > plan)
            return (<span>1</span>);
        else
            return (<span>∞</span>);
    }
    return (<i className={`tim-icons ${ data.plan <= plan ? "icon-check-2 included" : "icon-simple-remove notincluded" }`}></i>);
}

const Plans = (props) => {
    const { t } = useTranslation(['plans', 'vip']);
    return (
        <>
            <div className="plansContainer">
                <motion.div initial={{ opacity: 0.5, x: -100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
                    <h2>{t(`title.plans`)}</h2>
                </motion.div>
                <motion.div initial={{ opacity: 0.5, x: 100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
                    <Card className="plans">
                        <div className="content">
                            <Table responsive>
                                <thead className="text-primary">
                                    <tr key="titles">
                                        <th>{t('title.features')}</th>
                                        <th>{t('title.light')}</th>
                                        <th>{t('title.regular')}</th>
                                        <th>{t('title.chad')}</th>
                                    </tr>
                                </thead>
                                <tbody className="tBodySettings">
                                    {
                                        features.map(e => {
                                            return (<>
                                                    <tr key={e.key} className='prim'>
                                                        <td><div><span>{t(`${e.key}.title`)}</span><br></br><small>{t(`${e.key}.desc`)}</small></div></td>
                                                        <td>{renderFeature(t, e, 1)}</td>
                                                        <td>{renderFeature(t, e, 2)}</td>
                                                        <td>{renderFeature(t, e, 3)}</td>
                                                    </tr>
                                                    {e.sub && e.sub.map(s => {
                                                        return(<>
                                                            <tr key={s.key} className='sub'>
                                                                <td><i>●</i>
                                                                <div><span>{t(`${s.key}.title`)}</span><br></br><small>{t(`${s.key}.desc`)}</small></div></td>
                                                                <td>{renderFeature(t, s, 1)}</td>
                                                                <td>{renderFeature(t, s, 2)}</td>
                                                                <td>{renderFeature(t, s, 3)}</td>
                                                            </tr>
                                                        </>)
                                                    })}
                                                </>);
                                        })
                                    }
                                    <tr className="prices">
                                        <td></td>
                                        <td>0.99€/mo</td>
                                        <td>4.99€/mo</td>
                                        <td>9.99€/mo</td>
                                    </tr>
                                    <tr className="payments">
                                        <td></td>
                                        <td><div className="paypalBtn">
                                                {props.logged && props.vip.plan < 3 ? (<PayPalButtons
                                                    shippingPreference="NO_SHIPPING"
                                                    options={{
                                                        clientId: "AW4TzZa-fG-R2Yc619abB0SLHkvVlklD7pUgBW14H9Mkgs0QJyp52DUK6Rp3EVBP_HzXXaOPRNyQU7a6",
                                                        currency: "EUR",
                                                        vault: true,
                                                        intent: 'subscription'
                                                    }}
                                                    style={{
                                                        shape: 'rect',
                                                        color: 'blue',
                                                        layout: 'vertical',
                                                        label: 'paypal'
                                                    }}
                                                    onApprove={async (data, actions) => {
                                                        toast.success(t(`vip:payment`));
                                                    }}
                                                    createSubscription={async (data, actions) => {
                                                        const id = await actions.subscription.create({
                                                            plan_id: 'P-5R215077SG7847815MGX3KLI',
                                                            quantity: 1
                                                        });
                                                        props.sendPaypalTransaction(id);
                                                        return id;
                                                    }}
                                                />) : (<></>)}
                                            </div></td>
                                        <td><div className="paypalBtn">
                                                {props.logged && props.vip.plan < 2 ? (<PayPalButtons
                                                    shippingPreference="NO_SHIPPING"
                                                    options={{
                                                        clientId: "AW4TzZa-fG-R2Yc619abB0SLHkvVlklD7pUgBW14H9Mkgs0QJyp52DUK6Rp3EVBP_HzXXaOPRNyQU7a6",
                                                        currency: "EUR",
                                                        vault: true,
                                                        intent: 'subscription'
                                                    }}
                                                    style={{
                                                        shape: 'rect',
                                                        color: 'blue',
                                                        layout: 'vertical',
                                                        label: 'paypal'
                                                    }}
                                                    onApprove={async (data, actions) => {
                                                        toast.success(t(`vip:payment`));
                                                    }}
                                                    createSubscription={async (data, actions) => {
                                                        const id = await actions.subscription.create({
                                                            plan_id: 'P-2CC48975Y83927200MEUVC4A',
                                                            quantity: 1
                                                        });
                                                        props.sendPaypalTransaction(id);
                                                        return id;
                                                    }}
                                                />) : (<></>)}
                                            </div></td>
                                        <td><div className="paypalBtn">
                                                {props.logged && props.vip.plan < 3 ? (<PayPalButtons
                                                    shippingPreference="NO_SHIPPING"
                                                    options={{
                                                        clientId: "AW4TzZa-fG-R2Yc619abB0SLHkvVlklD7pUgBW14H9Mkgs0QJyp52DUK6Rp3EVBP_HzXXaOPRNyQU7a6",
                                                        currency: "EUR",
                                                        vault: true,
                                                        intent: 'subscription'
                                                    }}
                                                    style={{
                                                        shape: 'rect',
                                                        color: 'blue',
                                                        layout: 'vertical',
                                                        label: 'paypal'
                                                    }}
                                                    onApprove={async (data, actions) => {
                                                        toast.success(t(`vip:payment`));
                                                    }}
                                                    createSubscription={async (data, actions) => {
                                                        const id = await actions.subscription.create({
                                                            plan_id: 'P-6P1188188C6148822MGAAWDA',
                                                            quantity: 1
                                                        });
                                                        props.sendPaypalTransaction(id);
                                                        return id;
                                                    }}
                                                />) : (<></>)}
                                            </div></td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </Card>
                </motion.div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    const { vip } = state.infos;
    const { logged } = state.rLink;
    return { vip, logged };
};

const mapDispatchToProps = {
    sendPaypalTransaction
};

//export default Plans;
export default connect(mapStateToProps, mapDispatchToProps)(Plans);